import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import * as ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
  RouterProvider,
} from 'react-router-dom';

import { env } from '@packages/utils/env';

import { browserRouter } from './routes/browser-router';

import '@packages/core/i18n';
import '@packages/insights-widgets/locales/i18n'; // TODO: need to review the i18n strategy for packages
import './locales/i18n';

if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_BUILD_IDENTIFIER,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    beforeSend(event) {
      if (event?.exception?.values?.[0]?.mechanism?.handled) {
        return null; // Drop handled exceptions
      }
      return event;
    },
    tracesSampleRate: 1.0,
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<RouterProvider router={browserRouter} />);
